import { useMutation, useQueryClient } from "@tanstack/react-query";
import * as queries from '@supabase/queries';

export function useUpdateUserData() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ["userData--updateName"],
        mutationFn: async (data: {
            id: string,
            first_name: string,
            last_name: string
        }) => {
            const res = await queries.updateUserData(data);
            return res;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ["userData"]});
        }
    });
}
